module.exports = __webpack_public_path__ + "img/publications.7ded5d55.gif";